import { create } from 'zustand';

import { bannerStoreCreator } from './bannerStore';
import { State } from './types';
export * from './selector';
export type { Banner, BannerItem } from './types';

export const useBannerStore = create<State>(bannerStoreCreator);
